import { Component, OnInit, ViewChild } from '@angular/core';
import { PfsAllocationComponent } from './pfs-allocation/pfs-allocation.component';
import { PfsViewGridComponent } from './pfs-view-grid/pfs-view-grid.component';
import { PfsChartsComponent } from './pfs-charts/pfs-charts.component';
import { PfsSummaryComponent } from './pfs-summary/pfs-summary.component';
import { PfsClientChartsComponent } from './pfs-client-charts/pfs-client-charts.component';
import { PfsDashboardComponent } from './pfs-dashboard/pfs-dashboard.component';

@Component({
  selector: 'app-pfs',
  templateUrl: './pfs.component.html',
  styleUrls: ['./pfs.component.css']
})
export class PfsComponent implements OnInit {
  @ViewChild(PfsDashboardComponent) tabDashboard!: PfsDashboardComponent;
  @ViewChild(PfsAllocationComponent) tabAlloc!: PfsAllocationComponent;
  @ViewChild(PfsViewGridComponent) tabGrid!: PfsViewGridComponent;
  @ViewChild(PfsChartsComponent) tabCharts!: PfsChartsComponent;
  @ViewChild(PfsSummaryComponent) tabSummary!: PfsSummaryComponent;
  @ViewChild(PfsClientChartsComponent) tabClientCharts!: PfsClientChartsComponent;

  currentTab = 'dashboard';

  constructor() {}

  ngOnInit(): void {
    $('#pfsTabs').on('shown.bs.tab', (event) => {
      this.currentTab = event.target.id.replace('-tab', '');

      switch (this.currentTab) {
        case 'dashboard':
          //this.tabAlloc.loadData?.();
          break;
        case 'client-charts':
          //this.tabAlloc.loadData?.();
          break;
        case 'grid':
          //this.tabGrid.refreshGrid?.();
          break;
        case 'charts':
          //this.tabCharts.updateCharts?.();
          break;
        case 'summary':
          //this.tabSummary.loadSummary?.();
          break;
      }
    });
  }
}
